import script from "./QuestionnaireEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionnaireEdit.vue?vue&type=script&setup=true&lang=js"

import "./QuestionnaireEdit.vue?vue&type=style&index=0&id=368fadd4&lang=scss&scoped=true"
import "./QuestionnaireEdit.vue?vue&type=style&index=1&id=368fadd4&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368fadd4"]])

export default __exports__